module.exports = __webpack_public_path__ + "static/media/giftcard-babyshower-mobile.bee01801.png";